import { DatePicker, Form, Input, Select, Spin } from "antd";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GenderData, YesNoData } from "../../../../data";
import svg92 from "../../../../assets/svg/svg92.svg";
import svg85 from "../../../../assets/svg/svg85.svg";
import PhoneInput from "react-phone-input-2";
import { fetchData } from "../../../../features/dropdown/dropdownSlice";
import { cleanBlock, setActiveObj } from "../../../../features/folder/folderSlice";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { normalizeDateToLocalYear } from "../../../../utils";

const { TextArea } = Input;
function ActivitySetting({ handleNext, handleBack, form }) {
  const urlPanel = "v1/ap/panel/getAll";
  const urlAssignee = "api/v1/employee/getAll";

  const { dataPanel, dataAssignee, activeObjActivity } = useSelector(
    (state) => ({
      dataPanel: state.dropdown.data[urlPanel] || [],
      dataAssignee: state.dropdown.data[urlAssignee] || [],
      activeObjActivity: state.folder.activeObj["activity"],
    })
  );

  const { saving } = useSelector((state) => state.save);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handlePrev = async () => {
    await handleBack();
  };

  async function handleSubmitStep() {
    try {
      const values = await form.validateFields();
      const res = await dispatch(
        save({
          url: "api/v1/activities/create",
          jaaId: activeObjActivity?.jaaId ?? null,
          jaaStartDate: normalizeDateToLocalYear(values?.jaaStartDate),
          ...values,
        })
      );

      if (res?.payload?.success) {
        await toast.success(res.payload.messages.message);
        await dispatch(
          setActiveObj({ key: "activity", data: res?.payload?.data?.result })
        );
        await dispatch(cleanBlock())
        await handleNext();
      } else {
        toast.error(res.payload?.messages?.message);
      }
    } catch (error) {
      console.log("Error in saving form:", error);
    }
  }

  useEffect(() => {
    dispatch(
      fetchData({
        url: urlPanel,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlAssignee,
        limit: null,
        start: 0,
      })
    );
  }, []);

  return (
    <>
      <div className="text-lightBlack text-[1.5rem] font-dmSans font-[600]">
        Activity Setting
      </div>
      <div className="text-[#0E0E0E] text-[1.125rem] font-[500] font-dmSans">
        Fill with relevant infomation
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10 mt-[1.5rem]">
        <Form.Item
          name="jaaStartDate"
          rules={[
            {
              required: true,
              message: "Date is required",
            },
          ]}
          label="Date"
        >
          <DatePicker format={"YYYY MMM DD"} className="input" />
        </Form.Item>
        <Form.Item
          name="jaaLocation"
          label={"Location"}
          rules={[
            {
              required: true,
              message: "Please add Location",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>
      </div>
      <Form.Item
        name="jaaMeetingUrl"
        label={"Virtual Meeting Link"}
        rules={[
          { required: false, message: "Please add virtual meeting link" },
          { type: "url", message: "Please enter a valid URL" },
        ]}
      >
        <Input className="input" />
      </Form.Item>
      <Form.Item
        name="jaaPaId"
        className=""
        label={"Interview Panel"}
        rules={[
          {
            required: true,
            message: "Please select interview panel",
          },
        ]}
      >
        <Select
          className=""
          allowClear
          style={{
            width: "100%",
          }}
          options={
            dataPanel?.length > 0 &&
            dataPanel?.map((item) => ({
              value: item?.paId,
              label: item?.paName,
            }))
          }
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label?.toLocaleLowerCase() ?? "").includes(
              input?.toLocaleLowerCase()
            )
          }
        />
      </Form.Item>

      <Form.Item
        name="jaaAssigneeId"
        className=""
        label={"Select Assignee"}
        rules={[
          {
            required: false,
            message: "Please select assignee",
          },
        ]}
      >
        <Select
          className=""
          allowClear
          style={{
            width: "100%",
          }}
          options={
            dataAssignee?.length > 0 &&
            dataAssignee?.map((item) => ({
              value: item?.ppId,
              label: item?.ppFullname,
            }))
          }
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label?.toLocaleLowerCase() ?? "").includes(
              input?.toLocaleLowerCase()
            )
          }
        />
      </Form.Item>

      <div className="flex lg:flex-row flex-col lg:items-center justify-between lg:gap-0  gap-5 w-full mt-[3.5rem]">
        <div
          className="flex items-center text-[#706F6F] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
          onClick={() => handlePrev()}
        >
          <img src={svg85} alt="svg85" /> Back
        </div>
        <div className="justify-end flex items-center gap-x-2">
          <div className="w-[100px]">
            <button
              key="back"
              type="button"
              className="cstm-btn-2"
              onClick={() => handlePrev()}
            >
              Cancel
            </button>
          </div>

          <div className="w-[230px]">
            <button
              key="submit"
              type="submit"
              className="cstm-btn"
              onClick={handleSubmitStep}
              disabled={saving}
            >
              <span className="flex items-center  gap-x-3 ">
                {saving ? (
                  <Spin />
                ) : (
                  <>
                    {" "}
                    Save And Proceed <img src={svg92} alt="svg92" />
                  </>
                )}
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ActivitySetting;
